export default {
    data() {
        return {
            cvLink: 'https://web-jbll.s3.eu-west-3.amazonaws.com/Curriculum_JBLL.pdf',
            datadistaLink: 'https://github.com/datadista/datasets/tree/master/COVID%2019',
            gitHubBicisLink: 'https://github.com/JBenitoL/JBicisPro',
            gitHubCoronaLink: 'https://github.com/JBenitoL/Covid19BotAWS',
            gitHubLink: 'https://github.com/JBenitoL',
            gitHubSWLink: 'https://github.com/LowTemperaturesUAM/AppBLQ',
            gitHubTelegramLink: 'https://web.telegram.org/#/im?p=@DataCorona_bot',
            gitHubWebLink: 'https://github.com/JBenitoL/WebSource',
            labLink: 'http://webs.fmc.uam.es/lbtuam.group/',
            linkedinLink: 'https://www.linkedin.com/in/jbenitollorens/',
            tesisLink: 'http://webs.fmc.uam.es/lbtuam.group/TesisJBLLOficial.pdf'
        }
    }
}